import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import router from './router'
import './lib/axios'
import 'leaflet/dist/leaflet.css'

import { configure, defineRule } from 'vee-validate'
import { localize } from '@vee-validate/i18n'
import { required } from '@vee-validate/rules'
import { loadMessages, getMessages } from '@/utils/message'
import { useErrorStore } from '@/stores/error'

async function bootstrap() {
  // バリデーションルール登録
  defineRule('required', required)
  // 文字列の最大長チェック
  defineRule('max_length', (value: any, [limit]: any[]) => {
    if (typeof value !== 'string') return true
    return value.length <= Number(limit)
  })
  // 数値範囲＋小数桁数チェック（第3引数は任意）
  defineRule(
    'between',
    (value: string | number | null | undefined, [min, max, places]: [number, number, number?]) => {
      if (value === '' || value === null || value === undefined) return true

      const str = String(value)
      const num = Number(str)
      if (isNaN(num)) return false

      const inRange = num >= Number(min) && num <= Number(max)
      if (!inRange) return false

      // places が指定されていれば小数桁もチェック（整数なら 0 桁）
      if (places !== undefined && places !== null) {
        const dot = str.indexOf('.')
        const decimals = dot === -1 ? 0 : str.length - dot - 1
        return decimals <= Number(places)
      }

      return true
    },
  )
  // messages.json をロード
  await loadMessages()

  // VeeValidate ローカライズ設定
  configure({
    generateMessage: localize('ja', {
      messages: getMessages(),
      names: {
        loginName: 'ユーザID',
        loginPassword: 'パスワード',
        droneName: '機体名',
        comment: 'メモ',
        windCaution: '風速注意',
        windWarning: '風速警戒',
        rainCaution: '降水注意',
        rainWarning: '降水警戒',
        snowCaution: '降雪注意',
        snowWarning: '降雪警戒',
        heatCaution: '気温（耐暑注意）',
        heatWarning: '気温（耐暑警戒）',
        coldCaution: '気温（耐寒注意）',
        coldWarning: '気温（耐寒警戒）',
        areaName: '飛行エリア名',
        latitude: '緯度',
        longitude: '経度',
        routeName: '航路名',
      },
    }),
    // VeeValidate のトリガーを blur のみに
    validateOnBlur: true,
    validateOnInput: false,
    validateOnChange: false,
    validateOnModelUpdate: false,
  })

  // アプリ初期化
  const app = createApp(App)
  app.use(createPinia())
  app.use(router)

  // エラー復元
  const errorStore = useErrorStore()
  errorStore.loadErrorFromSession()

  app.mount('#app')
}

// 起動
bootstrap()
